<template>
  <!-- Navigation (already exists in your app) -->
  <nav class="custom-nav blue-grey darken-3">
    <div class="nav-wrapper">
      <!-- Your existing navigation content -->
      <ul class="right">
        <li><a href="#"><i class="material-icons">notifications</i></a></li>
        <li><a href="#"><i class="material-icons">account_circle</i></a></li>
      </ul>
    </div>
  </nav>

  <!-- Header Section with Profile -->
  <div class="dashboard-header blue-grey darken-3 white-text">
    <div class="container header-content">
      <div class="profile-section">
        <div class="profile-image-container">
          <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Profile" class="profile-image circle">
          <span class="status-indicator green"></span>
        </div>
        <div class="profile-info">
          <h5 class="welcome-text">Hello, Master of Things</h5>
          <p class="header-subtitle">Here's what's happening today</p>
        </div>
      </div>
      <div class="header-actions">
        <div class="date-display">
          <i class="material-icons">calendar_today</i> <span> {{ currentDate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick Stats -->
  <div class="container">
    <div class="quick-stats row">
      <div class="col s6 m3" v-for="stat in stats" :key="stat.id">
        <div class="center-align quick-stat-item white z-depth-1" :style="`border-bottom: 4px solid ${stat.color};`">
          <div class="stat-icon circle" :class="stat.bgColor">
            <i class="material-icons white-text">{{ stat.icon }}</i>
          </div>
          <div class="stat-value blue-grey-text text-darken-3">{{ stat.value }}</div>
          <div class="stat-label blue-grey-text text-lighten-1">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="container main-content">
    <!-- Modules Grid -->
    <div class="section">

      <div class="section-header-minimal-extended">
        <div class="header-content-wrapper">
          <h5 class="header-title">Your Modules</h5>
          <div class="title-underline">
            <div class="underline"></div>
            <div class="line-extender"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m6 l4" v-for="tab in tabs" :key="tab.id">
          <router-link :to="{ name: tab.to }">
            <div class="modern-card z-depth-1 hoverable" :class="tab.card">
              <div class="card-content">
                <div class="card-header">
                  <div class="card-icon-container" :class="tab.bgColor">
                    <i class="material-icons">{{ tab.icon }}</i>
                  </div>
                  <span class="badge new yellow lighten-3 green-text text-darken-2" v-if="tab.notification">{{
                    tab.notification }}</span>
                </div>
                <h6 class="card-title">{{ tab.title }}</h6>
                <p class="card-desc" v-if="tab.description">{{ tab.description }}</p>
                <div class="card-action">
                  <span class="btn-flat waves-effect waves-light blue-grey-text text-darken-2">
                    Access <i class="material-icons right">arrow_forward</i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="center-align empty-state" v-if="tabs.length === 0">
      <i class="large material-icons blue-grey-text text-lighten-2">inbox</i>
      <p class="blue-grey-text text-lighten-2">No modules available</p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import getItems from "@/composables/getItems";
import { addModules } from "@/composables/cache/modules";
import { useStore } from "vuex";

export default {
  name: "HomeView",
  setup() {
    const tabs = ref([]);
    const stats = ref([
      {
        id: 1, label: "Active Users", value: "1,243", icon: "people",
        color: "#4CAF50", bgColor: "green lighten-1"
      },
      {
        id: 2, label: "Pending Tasks", value: "27", icon: "assignment",
        color: "#FF9800", bgColor: "orange lighten-1"
      },
      {
        id: 3, label: "New Messages", value: "14", icon: "email",
        color: "#2196F3", bgColor: "blue lighten-1"
      },
      {
        id: 4, label: "System Health", value: "98%", icon: "show_chart",
        color: "#9C27B0", bgColor: "purple lighten-1"
      }
    ]);

    // store
    const store = useStore();

    // title
    onMounted(() => {
      document.title = "Admin";
    });

    // display
    onMounted(() => {
      let sourceTabs = addModules();
      if (store.state.user) {
        tabs.value = sourceTabs.filter(x => store.state.user.modules.includes(x.to));

        // Add color properties to tabs
        const colors = ["teal", "blue", "indigo", "cyan", "purple", "deep-purple"];
        tabs.value.forEach((tab, index) => {
          tab.bgColor = `${colors[index % colors.length]} lighten-4`;
        });
      } else {
        tabs.value = [];
      }
    });

    // get alerts
    onMounted(() => {
      alerts();
    });

    const alerts = () => {
      (async () => {
        const { res } = await getItems(`operator/starter?u=${store.state.user?.id}`);
        if (res.value) {
          res.value.data.forEach((x) => {
            tabs.value.forEach((z) => {
              if (x.name === z.to) {
                z.notification = x.message;
              }
            })
          })
        }
      })();
    };

    // Inside your setup() function
    const currentDate = ref(new Date().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric'
    }));

    return {
      tabs,
      stats,
      currentDate,
    };
  },
};
</script>

<style scoped>
.dashboard-container {
  min-height: 100vh;
  background-color: #f5f7f9;
}

.dashboard-header {
  padding: 30px 0;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.profile-section {
  display: flex;
  align-items: center;
}

.profile-image-container {
  position: relative;
  margin-right: 20px;
}

.profile-image {
  width: 70px;
  height: 70px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  object-fit: cover;
}

.status-indicator {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #37474f;
}

.status-indicator.green {
  background-color: #4CAF50;
}

.profile-info {
  display: flex;
  flex-direction: column;
}

.welcome-text {
  font-weight: 300;
  margin: 0;
  font-size: 1.8rem;
}

.header-subtitle {
  opacity: 0.8;
  margin: 5px 0 0;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.header-actions a {
  border-radius: 20px;
  opacity: 0.9;
}

.header-actions a:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.quick-stats {
  margin: -40px 0 40px;
  position: relative;
  z-index: 2;
}

.quick-stat-item {
  position: relative;
  padding: 25px 10px 20px;
  border-radius: 10px;
  transition: all 0.3s ease;
  margin: 0 5px;
}

.quick-stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  height: 50px;
  width: 50px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  font-weight: 500;
}

.main-content {
  padding-bottom: 40px;
}

.section-title {
  margin-bottom: 30px;
}

.section-title h5 {
  font-weight: 500;
  color: #37474f;
  margin: 0 0 5px;
}

.section-subtitle {
  color: #78909c;
  margin: 0;
}

.modern-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin-bottom: 25px;
  background: white;
}

.modern-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12), 0 10px 10px rgba(0, 0, 0, 0.08) !important;
}

.card-content {
  padding: 25px;
  position: relative;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.card-icon-container {
  height: 60px;
  width: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon-container i {
  font-size: 28px;
}

.card-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #37474f;
  margin: 0 0 12px;
}

.card-desc {
  color: #78909c;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 20px;
}

.card-action {
  border-top: 1px solid #f1f1f1;
  padding-top: 15px;
  margin-top: 10px;
}

.btn-flat {
  padding: 0 5px;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
}

.empty-state {
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}


/* Option 6: Improved Minimal Header with Extended Line */
.section-header-minimal-extended {
  margin: 0 0 30px 0;
  padding-left: 15px;
  /* Matches card padding */
}

.header-content-wrapper {
  display: flex;
  flex-direction: column;
  width: calc(100% + 15px);
  /* Extend to account for container padding */
  margin-left: -15px;
  /* Counteract the container padding */
}

.section-header-minimal-extended .header-title {
  margin: 0 0 8px 15px;
  /* Add left margin to realign text */
  color: #37474F;
  font-weight: 500;
  display: inline-block;
}

.title-underline {
  display: flex;
  width: 100%;
  align-items: center;
}

.title-underline .underline {
  height: 2px;
  width: 50px;
  background: #2196F3;
  flex-shrink: 0;
  margin-left: 15px;
  /* Align with text */
}

.title-underline .line-extender {
  height: 1px;
  background: #e0e0e0;
  flex-grow: 1;
  margin-right: 15px;
  /* Prevent overflow by accounting for container padding */
}
</style>
